import {
  GreyGrey90,
  Image,
  Primary13Regular,
  Box,
  Flex
} from '@sequencehq/core-components'
import netsuiteCover from './netsuiteCover.png'

export const NetsuiteIntegrationDetail = () => {
  return (
    <Flex flexDirection="column" gap="20px">
      <Image
        src={netsuiteCover}
        width="100%"
        borderRadius="8px"
        draggable={false}
      />
      <Box {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
        Connect the NetSuite integration to keep your billing and accounting
        data in sync.
      </Box>
      <Box {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
        Customers, products, invoices and credit notes sync directly between
        Sequence and NetSuite. Payments recorded in NetSuite are reflected back
        in Sequence automatically, so invoice statuses stay up to date while
        reconciliation remains in your ERP.
      </Box>
      <Box {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
        For companies using NetSuite ARM, Sequence billing schedules also sync
        as sales orders, giving NetSuite the contract data it needs to create
        revenue arrangements and recognize revenue.
      </Box>
    </Flex>
  )
}
